var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OrderFormContainer"},[_c('transition',{attrs:{"name":"slide-left","mode":"out-in"}},[_c('router-view',{ref:"routerView"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }